import { gql } from '@apollo/client';

export const CLOSE_COMMANDO_MUTATION = gql`
  mutation CloseCommando($id: Int!) {
    mcp {
      closeCommando(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
